'use es6';

import ActionTypes from '../actions/ActionTypes';
import { OrderedSet, Map as ImmutableMap } from 'immutable';
export const initialFavoritesState = {
  isGetFavoritesRequesting: true,
  isGetFavoritesError: false,
  isFavoriteEditRequesting: ImmutableMap({
    tracks: ImmutableMap(),
    lessons: ImmutableMap()
  }),
  isFavoriteEditError: ImmutableMap({
    tracks: ImmutableMap(),
    lessons: ImmutableMap()
  }),
  favorites: OrderedSet(),
  cumulativeFavorites: OrderedSet(),
  newFavouriteLessonId: null,
  newFavouriteTrackId: null
};
export const getUpdatedResponseState = ({
  state,
  contentType,
  contentId,
  isRequesting,
  isError
}) => ({
  isFavoriteEditRequesting: state.isFavoriteEditRequesting.setIn([contentType, contentId], isRequesting),
  isFavoriteEditError: state.isFavoriteEditError.setIn([contentType, contentId], isError)
});
export function Favorites(state = initialFavoritesState, action) {
  switch (action.type) {
    case ActionTypes.BOOKMARKS_GET_REQUESTING:
      {
        return Object.assign({}, state, {
          isGetFavoritesRequesting: true,
          isGetFavoritesError: false
        });
      }

    case ActionTypes.BOOKMARKS_GET_RECEIVED:
      {
        const favorites = action.payload.favorites.map(mark => ImmutableMap({
          [mark.get('contentType') === 'LESSON' ? 'lessonId' : 'trackId']: mark.get('contentId').toString()
        }));
        return Object.assign({}, state, {
          favorites,
          cumulativeFavorites: favorites,
          isGetFavoritesRequesting: false,
          isGetFavoritesError: false
        });
      }

    case ActionTypes.BOOKMARKS_GET_ERROR:
      {
        return Object.assign({}, state, {
          isGetFavoritesRequesting: false,
          isGetFavoritesError: true
        });
      }

    case ActionTypes.BOOKMARKS_EDIT_TRACK_REQUESTING:
      {
        return Object.assign({}, state, {}, getUpdatedResponseState({
          state,
          contentType: 'tracks',
          contentId: action.payload.trackId,
          isRequesting: true,
          isError: false
        }));
      }

    case ActionTypes.BOOKMARKS_ADD_TRACK_RECEIVED:
      {
        const contentId = action.payload.trackId;
        return Object.assign({}, state, {}, getUpdatedResponseState({
          state,
          contentType: 'tracks',
          contentId,
          isRequesting: false,
          isError: false
        }), {
          favorites: OrderedSet([ImmutableMap({
            trackId: contentId
          })]).concat(state.favorites),
          cumulativeFavorites: OrderedSet(!state.cumulativeFavorites.find(mark => mark.get('trackId') === contentId) ? [ImmutableMap({
            trackId: contentId
          })] : []).concat(state.cumulativeFavorites),
          newFavouriteTrackId: action.payload.trackId
        });
      }

    case ActionTypes.BOOKMARKS_REMOVE_TRACK_RECEIVED:
      {
        return Object.assign({}, state, {}, getUpdatedResponseState({
          state,
          contentType: 'tracks',
          contentId: action.payload.trackId,
          isRequesting: false,
          isError: false
        }), {
          favorites: state.favorites.filterNot(mark => mark.get('trackId') === action.payload.trackId)
        });
      }

    case ActionTypes.BOOKMARKS_EDIT_TRACK_ERROR:
      {
        return Object.assign({}, state, {}, getUpdatedResponseState({
          state,
          contentType: 'tracks',
          contentId: action.payload.trackId,
          isRequesting: false,
          isError: true
        }));
      }

    case ActionTypes.BOOKMARKS_EDIT_LESSON_REQUESTING:
      {
        return Object.assign({}, state, {}, getUpdatedResponseState({
          state,
          contentType: 'lessons',
          contentId: action.payload.lessonId,
          isRequesting: true,
          isError: false
        }));
      }

    case ActionTypes.BOOKMARKS_ADD_LESSON_RECEIVED:
      {
        const contentId = action.payload.lessonId;
        return Object.assign({}, state, {}, getUpdatedResponseState({
          state,
          contentType: 'lessons',
          contentId,
          isRequesting: false,
          isError: false
        }), {
          favorites: OrderedSet([ImmutableMap({
            lessonId: contentId
          })]).concat(state.favorites),
          cumulativeFavorites: OrderedSet(!state.cumulativeFavorites.find(mark => mark.get('lessonId') === contentId) ? [ImmutableMap({
            lessonId: contentId
          })] : []).concat(state.cumulativeFavorites),
          newFavouriteLessonId: {
            lessonId: action.payload.lessonId
          }
        });
      }

    case ActionTypes.BOOKMARKS_REMOVE_LESSON_RECEIVED:
      {
        const contentId = action.payload.lessonId;
        return Object.assign({}, state, {}, getUpdatedResponseState({
          state,
          contentType: 'lessons',
          contentId,
          isRequesting: false,
          isError: false
        }), {
          favorites: state.favorites.filterNot(mark => mark.get('lessonId') === contentId)
        });
      }

    case ActionTypes.BOOKMARKS_EDIT_LESSON_ERROR:
      {
        return Object.assign({}, state, {}, getUpdatedResponseState({
          state,
          contentType: 'lessons',
          contentId: action.payload.lessonId,
          isRequesting: false,
          isError: true
        }));
      }

    default:
      return state;
  }
}
export default Favorites;